import { apiGet } from '@/lib/http/client';

import type { MailchimpStatusResponse } from '../types';

export async function getMailchimpStatus(
  orgId: number | string
): Promise<MailchimpStatusResponse> {
  return apiGet<MailchimpStatusResponse>(
    `/api/orgs/${orgId}/mailchimp/status/`
  );
}
